import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http'; 

import { ComponentLoaderFactory, PositioningService } from './sheared/ngx-bootstrap';
import { AppComponent } from './app.component';
import { TypeaheadModule } from './sheared/ngx-bootstrap/typeahead';
import { SearchComponent } from './serchComponent/search.component';
import { ProductSearchService } from './services/productSearch.service';

@NgModule({
  declarations: [
      AppComponent,
      SearchComponent
  ],
  imports: [
      BrowserModule,
      TypeaheadModule,
      FormsModule,
      HttpModule
  ],
  providers: [
      ComponentLoaderFactory,
      PositioningService,
      ProductSearchService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/websites/emusic-search-WA/emusic2018/emusic2018/SPA/src/app/app.module.ts